






import { Component, Vue } from 'vue-property-decorator';
import LocationsPage from '@/views/Settings/Locations/Locations.vue';

@Component({
  components: {
    LocationsPage
  }
})
export default class Locations extends Vue {}
